import React, { useState } from 'react';
import './ChatWidget.css';

const starterMessages = [
  { from: 'bot', text: 'Hi! How can we help today?' },
  { from: 'bot', text: 'Ask about sizing, adaptive features, or order support.' },
];

function ChatWidget() {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState(starterMessages);
  const [input, setInput] = useState('');

  const sendMessage = () => {
    const text = input.trim();
    if (!text) return;
    setMessages((prev) => [
      ...prev,
      { from: 'user', text },
      {
        from: 'bot',
        text: "Thanks for reaching out! We'll get back to you shortly.",
      },
    ]);
    setInput('');
  };

  return (
    <div className={`chat-widget ${open ? 'open' : ''}`}>
      <button className="chat-toggle" onClick={() => setOpen(!open)}>
        Chat with us
      </button>

      {open && (
        <div className="chat-panel">
          <header className="chat-header">
            <div>
              <p className="chat-title">Chat with The Shapes United</p>
              <p className="chat-subtitle">We typically reply in a few hours</p>
            </div>
            <button className="chat-close" onClick={() => setOpen(false)}>
              ×
            </button>
          </header>

          <div className="chat-messages">
            {messages.map((msg, idx) => (
              <div
                key={idx}
                className={`chat-bubble ${msg.from === 'user' ? 'user' : 'bot'}`}
              >
                {msg.text}
              </div>
            ))}
          </div>

          <div className="chat-input">
            <input
              type="text"
              placeholder="Type your message..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') sendMessage();
              }}
            />
            <button onClick={sendMessage}>Send</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default ChatWidget;
